<div class="contato-tipo-select dropdown"
    [class.invalid]="!config.isValid">
    <button class="btn btn-light dropdown-toggle" #dropdownToggle type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled"
        [name]="name"
        [id]="id">
        <ng-template [ngIf]="tipo">
            <span>
                <i class="{{tipo.iconClass}}"></i>
                {{tipo.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!tipo">
            <span>
                Nenhum Tipo
            </span>
        </ng-template>        
    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    [class.dropdown-item-select]="!ngModel"
                    (click)="onChange(null)">
                    Nenhum Tipo
                </a>
                <a *ngFor="let item of tiposOptions" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="item.id == ngModel"
                    (click)="onChange(item)">
                    <i class="{{item.iconClass}}"></i>
                    {{item.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>